module.exports = __webpack_public_path__ + "font_beautiful_daughter.5b2c2b72.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/font_beautiful_daughter.png
// module id = FIbV
// module chunks = 0